import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-cft-missing",
  templateUrl: "./cft-missing.component.html",
  styleUrls: ["./cft-missing.component.css"],
})
export class CftMissingComponent implements OnInit {
  imageURL: string = null;
  @Input('tellMes') tellMes: any;
  @Input('types') types: any;

  review: boolean = false;
  whitelabelData: any = {
	'pd': {
		'appName': '',
		'logoDark': '',
		'logoLight': '',
	}
};

  constructor(private route: ActivatedRoute) {
    let whitelabelData = localStorage.getItem('whitelabelData');
if(whitelabelData) {
      this.whitelabelData = JSON.parse(whitelabelData);
    }
  }

  features: any = [
    {
      title: "How to set it up",
      description:
        'Configure Swayam to keep a hawk eye on 20 critical security and governance change events occurring on your infrastructure using "Tell Me".',
      img: "https://s3.ap-south-1.amazonaws.com/v3.assets.swayam.cloud/swayam-features/tell-me/configure-tell-me.png",
      textalign: "left",
    },
    {
      title: "Get Notified",
      description:
        "Get Notification in your email, within 30 mins of the event/incident occuring",
      img: "https://s3.ap-south-1.amazonaws.com/v3.assets.swayam.cloud/swayam-features/tell-me/email-tell-me.png",
      textalign: "right",
    },
    {
      title: "History",
      description:
        "Get 90 days historical data of the events/incidents, recorded using Swayam",
      img: "https://s3.ap-south-1.amazonaws.com/v3.assets.swayam.cloud/swayam-features/tell-me/history-tell-me.png",
      textalign: "left",
    },
  ];

  ngOnInit(): void {}
}
